(function($) {
	
	//'use strict';
	var body = $('body');
	var suggestionQuery;
	var suggestionIsOpen = false;
	var suggestionRow = 0;
	var suggestionColumn = 1;
	var suggestionCurrentInput;
	var suggestionCurrentDropdown;

	var currURL;	

	var rechercheFiltresListSousitem;
	var rechercheFiltresLabel;
	var rechercheRegionInput;
	var rechercheRegionBtn;
	
	var rechercherContentFiltreListeBtn;
	var rechercheContentMapResultsBtn;
	var rechercheContentFiltreFiltresBtn;
	
	var rechercheOptionItemDel;
	
	var recherchePopup;
	var recherchePopupCloseBtn;
	var recherchePopupLangItemCtn;
	var recherchePopupRegionsItemCtn;
	var recherchePopupLangItem;
	var recherchePopupRegionsItem;
	var recherchePopupClosePannel;
	var recherchePopupRegion;
	var recherchePopupRedirectBtn;
	
	var rechercheOrganisationVueBtn;
	
	var rechercheHeaderFiltersDelBtn;
	
	var rechercheOrderBtnDist;
	
	var rechercheQuery;
	
	var gmapResterResearchBtn;
    
    var GLLMontreal;
	var GAutocompleteService;
	var GPlacesService;
	
	var rechercheSubfilterToggle = function () {
		var t = $(this);
		var ctn = t.closest('.recherche-filtre-sub-list-item');
		var fx = ctn.hasClass('active') ? 'removeClass' : 'addClass';
		
		ctn[fx]('active');
	};
	
	var rechercheFiltresLabeltoggle = function () {
		var t = $(this);
		var ctn = t.closest('.recherche-header-filters-items-ctn');
		var tiroir = $('.recherche-header-filters-items-inner-ctn', ctn);
		
		if (ctn.hasClass('open')) {
			ctn.removeClass('open');
			tiroir.slideUp(300);
		} else {
			ctn.addClass('open');
			tiroir.slideDown(300);
		}
	};
	
	var rechercherContentFiltreListeBtnToggle = function () {
		var t = $(this);
		var ctn = t.closest('.recherche-content-filtre-liste');
		var tiroir = $('.recherche-content-filtre-liste-inner', ctn);
		
		if (ctn.hasClass('open')) {
			ctn.removeClass('open');
			tiroir.slideUp(500);
		} else {
			ctn.addClass('open');
			tiroir.slideDown(500);
		}
	};
	
	var rechercheFiltreTiroirOpen = function () {
		var item = $('.recherche-filtre-list-item.open');
		var tiroir = $('.recherche-filtre-sub-list', item);
		tiroir.slideDown(0);
	};
	
	var recherchePopupClose = function () {
		$('body').removeClass('open-popup');
		
		createCookie('popup-check', 'true', 1);
	};
	
	var outsideRecherchePopupClose = function (event) {
		if (!$(event.target).closest('.recherche-popup-content-ctn').length) {
			recherchePopupClose();
		}
	};
	
	var checkIfPopup = function () {
		var params = QueryString();
		var popupState = getCookie('popup-check');
		
		if (popupState !== 'true' && params.place === undefined) {
			$('body').addClass('open-popup');
		}
	};
	
	var rechercheRegionInputChange = function (e) {
		var t = $(this);
        // This function depends on the dropdownUpdateValue function so we defer to synchronize the event nicely
        // Skip if it's not called via DOM event
        if (!t.hasClass('selected') && e && e.target) {
            var o = this;
            setTimeout(() => {
                rechercheRegionInputChange.call(o, e);
            }, 40);
            return false;
        }
        
        var ctn = (t.hasClass("dropdown-select-pannel-item")) ? t.closest(".ref-ctn") : $(".ref-ctn");
		var currClicked;
		if (t !== undefined && t[0]) {
			currClicked = t.closest('.dropdown-select').find('.dropdown-select-btn').attr('data-designator');
		}
        
        var regionDropdown = $('.recherche-filtre-select.recherche-filtre-region', ctn);
		var regionDropdownInput = $('.dropdown-select-input', regionDropdown);
		var regionDropdownItems = $('.dropdown-select-pannel-item', regionDropdown);
        var aggloDropdown = $('.recherche-filtre-select.recherche-filtre-agglomeration', ctn);
		var aggloDropdownInput = $('.dropdown-select-input', aggloDropdown);
		var aggloDropdownItems = $('.dropdown-select-pannel-item', aggloDropdown);
        var villeDropdown = $('.recherche-filtre-select.recherche-filtre-ville', ctn);
		var villeDropdownInput = $('.dropdown-select-input', villeDropdown);
		var villeDropdownItems = $('.dropdown-select-pannel-item', villeDropdown);
		
		var regionDropdownItemsValue = regionDropdownItems.filter('.selected').attr('data-value');
		var aggloDropdownItemsValue = aggloDropdownItems.filter('.selected').attr('data-value');
		var villeDropdownItemsValue = villeDropdownItems.filter('.selected').attr('data-value');
		var newRegionValue = regionDropdownItemsValue === 'all' || regionDropdownItemsValue === undefined ? '' : regionDropdownItemsValue;
		var newAggloValue = aggloDropdownItemsValue === 'all' || aggloDropdownItemsValue === undefined ? '' : aggloDropdownItemsValue;
		var newVilleValue = villeDropdownItemsValue === 'all' || villeDropdownItemsValue === undefined ? '' : villeDropdownItemsValue;
		
        if (currClicked === 'city') {
            // Set region and MRC values when a city is chosen.
            if (newVilleValue !== '') {
                var sel = villeDropdownItems.filter('.selected');
                newAggloValue = aggloDropdownItems.filter('[data-value="' + sel.attr('data-agglo') + '"]').attr('data-value');
                newRegionValue = regionDropdownItems.filter('[data-value="' + sel.attr('data-region') + '"]').attr('data-value');
            }
        } else if (currClicked === 'agglo') {
            // Set region and city values when an MRC is chosen.
            if (aggloDropdownItemsValue !== villeDropdownItems.filter('.selected').attr('data-agglo')) {
                newVilleValue = '';
            }
            if (newAggloValue !== '') {
                var sel = aggloDropdownItems.filter('.selected');
                newRegionValue = regionDropdownItems.filter('[data-value="' + sel.attr('data-region') + '"]').attr('data-value');
            }
        } else if (currClicked === 'region') {
            // Reset MRC and city value when new region selected
            newAggloValue = '';
            newVilleValue = '';
        }
		
        // Reset dropdown list and show all of the options except region dropdown that always displays all options
        aggloDropdownItems.show().removeClass('hide').removeClass('selected');
        villeDropdownItems.show().removeClass('hide').removeClass('selected');
        // Reset current region selections
        regionDropdownItems.removeClass('selected');
        
		if (newRegionValue !== '') {
            // Hide agglo and city options of non matched region
            aggloDropdownItems.filter(':not([data-region="' + newRegionValue + '"])').hide().addClass('hide');
            villeDropdownItems.filter(':not([data-region="' + newRegionValue + '"])').hide().addClass('hide');
            // Update selected region
            var currentItem = regionDropdownItems.filter('[data-value="' + newRegionValue + '"]').addClass('selected');
            // Update title in the select box
            $('.dropdown-select-btn-value', regionDropdown).html(currentItem.text());
            // Update hidden submit input
            regionDropdownInput.val(newRegionValue);
		} else {
            regionDropdownItems.filter('[data-value="all"]').addClass('selected');
            $('.dropdown-select-btn-value', regionDropdown).html($('.dropdown-select-btn-value', regionDropdown).attr('data-default'));
            regionDropdownInput.val('all');
        }
		
		if (newAggloValue !== '') {
            // Hide city options of non matched agglo
            villeDropdownItems.filter(':not([data-agglo="' + newAggloValue + '"])').hide().addClass('hide');
            // Update selected agglo
            var currentItem = aggloDropdownItems.filter('[data-value="' + newAggloValue + '"]').addClass('selected');
            // Update title in the select box
            $('.dropdown-select-btn-value', aggloDropdown).html(currentItem.text());
            // Update hidden submit input
            aggloDropdownInput.val(newAggloValue);
        } else {
            aggloDropdownItems.filter('[data-value="all"]').addClass('selected');
            $('.dropdown-select-btn-value', aggloDropdown).html($('.dropdown-select-btn-value', aggloDropdown).attr('data-default'));
            aggloDropdownInput.val('all');
        }
		
		if (newVilleValue !== '') {
            // Update selected ville
            var currentItem = villeDropdownItems.filter('[data-value="' + newVilleValue + '"]').addClass('selected');
            // Update title in the select box
            $('.dropdown-select-btn-value', villeDropdown).html(currentItem.text());
            // Update hidden submit input
            villeDropdownInput.val(newVilleValue);
		} else {
            villeDropdownInput.filter('[data-value="all"]').addClass('selected');
            $('.dropdown-select-btn-value', villeDropdown).html($('.dropdown-select-btn-value', villeDropdown).attr('data-default'));
            villeDropdownInput.val('all');
        }
        
        // Always show the first 'all' options
		$('.dropdown-select-pannel-item[data-value="all"]', ctn).show().removeClass('hide');
	};
	
	var rechercheRegionSort = function () {
		$('.recherche-region-input-list div.dropdown-select-pannel-inner').each(function () {
			var t = $(this);
			
			var items = $('.dropdown-select-pannel-item:not([data-value="all"])', t).sort(function (a,b) {
				if ($('span',a).html().toLowerCase() < $('span',b).html().toLowerCase())
					return -1;
				  else if ($('span',a).html().toLowerCase() > $('span',b).html().toLowerCase())
					return 1;
				  else 
					return 0;
			});
			
			items.appendTo(t);
		});
	};
	
	var rechercheRegionInputSubmit = function () {
		var t = $(this);
        if (t.hasClass('processing')) {
            return;
        }
        t.addClass('processing');
        
		var url = location.href;
        var count = 0;
		
        var ctn = t.closest('.recherche-header-filters');
		var serveItem = $('.recherche-region-dessert-input .form-checkbox-input:checked', ctn);
		var field16Item = $('.recherche-covid-input .form-checkbox-input:checked', ctn);
		var placeInputItem = $('.recherche-header-filters-items.location-geo', ctn);
		var regionDropdownItems = $('.recherche-filtre-region', ctn);
		var aggloDropdownItems = $('.recherche-filtre-agglomeration', ctn);
		var villeDropdownItems = $('.recherche-filtre-ville', ctn);
		
		var placeInputValue = placeInputItem.val();
		var newRegionValue = $('.dropdown-select-input', regionDropdownItems).val() === 'all' || $('.dropdown-select-input', regionDropdownItems).val() === undefined ? '' : $('.dropdown-select-input', regionDropdownItems).val();
		var newAggloValue = $('.dropdown-select-input', aggloDropdownItems).val() === 'all' || $('.dropdown-select-input', aggloDropdownItems).val() === undefined ? '' : $('.dropdown-select-input', aggloDropdownItems).val();
		var newVilleValue = $('.dropdown-select-input', villeDropdownItems).val() === 'all' || $('.dropdown-select-input', villeDropdownItems).val() === undefined ? '' : $('.dropdown-select-input', villeDropdownItems).val();
		
		var serveValue = (serveItem.length === 0) ? "" : serveItem.val(); //field14
		var field16Value = (field16Item.length === 0) ? "" : field16Item.val();
		var placeValue = encodeURIComponent(placeInputValue);
		var field11Value = encodeURIComponent(newRegionValue);
		var field12Value = encodeURIComponent(newAggloValue);
		var field13Value = encodeURIComponent(newVilleValue);

        var valCal=(newVilleValue==='')?(newAggloValue===''?(newRegionValue===''?'':newRegionValue):newAggloValue):newVilleValue;
		// var valCal=(newVilleValue==='')?(newAggloValue===''?(newRegionValue===''?'':newRegionValue):newAggloValue):newAggloValue;

        var searchSort = false;
        
        if (t.hasClass('place-to-territory')) {
            // Be sure to pass a unique session token for each new session. Using the same token for more than one session will result in each request being billed individually
            var sessionToken = new google.maps.places.AutocompleteSessionToken();
            var request = {
                input: placeInputValue,
                sessionToken: sessionToken,
                location: GLLMontreal,
                radius: 200000 //meters
            };
            GAutocompleteService.getPlacePredictions(
                request, 
                function(predictions, status) {
                    if (status == google.maps.places.PlacesServiceStatus.OK && predictions) {
                        GPlacesService.getDetails(
                            {
                                placeId: predictions[0].place_id,
                                fields: ['address_component', 'geometry', 'name']
                            },
                            function(place, status) {
                                if (status == google.maps.places.PlacesServiceStatus.OK) {
                                    
									saveSessionVariable('lat', place.geometry.location.lat(), _complete);
        				saveSessionVariable('lng', place.geometry.location.lng(), _complete);

						saveSessionVariable('serve', serveValue, _complete);

						saveSessionVariable('place', valCal, _complete);
						saveSessionVariable('location', valCal, _complete);
						saveSessionVariable('field11', newRegionValue, _complete);
						saveSessionVariable('field12', newAggloValue , _complete);
						saveSessionVariable('field13', newVilleValue, _complete);

						url = updateQueryStringParameter(url, 'lat', place.geometry.location.lat());
						url = updateQueryStringParameter(url, 'lng', place.geometry.location.lng());

						url = updateQueryStringParameter(url, 'place',valCal);
						url = updateQueryStringParameter(url, 'field11', newRegionValue);
						url = updateQueryStringParameter(url, 'field12', newAggloValue);
						url = updateQueryStringParameter(url, 'field13', newVilleValue);
						url = updateQueryStringParameter(url, 'serve', serveValue);
						
						window.location.reload();
                                    // Final process is geolocalizeMeSave() in geolocalisation.js
                                } else {
                                    // Error from google service, proceed nevertheless
                                    _start();
                                }
                            }
                        );
                    } else {
                        // Error from google service, proceed nevertheless
                        _start();
                    }
                }
            );
        } else if (serveValue === '1' && (newVilleValue === '' && newAggloValue !== 'Laval' && newAggloValue !== 'Montreal' && newAggloValue !== 'Montr\xE9al') && !t.hasClass('recherche-header-filters-items-del')) {
            
var sessionToken = new google.maps.places.AutocompleteSessionToken();
var request = {
	input: valCal,
	sessionToken: sessionToken,
	location: GLLMontreal,
	radius: 200000 //meters
};
GAutocompleteService.getPlacePredictions(
	request, 
	function(predictions, status) {
		if (status == google.maps.places.PlacesServiceStatus.OK && predictions) {
			GPlacesService.getDetails(
				{
					placeId: predictions[0].place_id,
					fields: ['address_component', 'geometry', 'name']
				},
				function(place, status) {
					if (status == google.maps.places.PlacesServiceStatus.OK) {
						
						saveSessionVariable('lat', place.geometry.location.lat(), _complete);
        				saveSessionVariable('lng', place.geometry.location.lng(), _complete);

						saveSessionVariable('serve', serveValue, _complete);

						saveSessionVariable('place', valCal, _complete);
						saveSessionVariable('location', valCal, _complete);
						saveSessionVariable('field11', newRegionValue, _complete);
						saveSessionVariable('field12', newAggloValue , _complete);
						saveSessionVariable('field13', newVilleValue, _complete);

						url = updateQueryStringParameter(url, 'lat', place.geometry.location.lat());
						url = updateQueryStringParameter(url, 'lng', place.geometry.location.lng());

						url = updateQueryStringParameter(url, 'place',valCal);
						url = updateQueryStringParameter(url, 'field11', newRegionValue);
						url = updateQueryStringParameter(url, 'field12', newAggloValue);
						url = updateQueryStringParameter(url, 'field13', newVilleValue);
						url = updateQueryStringParameter(url, 'serve', serveValue);
						
						window.location.reload();
						// Final process is geolocalizeMeSave() in geolocalisation.js
					} else {
						// Error from google service, proceed nevertheless
						_start();
					}
				}
			);
		} else {
			// Error from google service, proceed nevertheless
			_start();
		}
	}
);

//////

			t.removeClass('processing');
            $(".specify-city-warning").slideDown(200);
        } else {
			
///////

var sessionToken = new google.maps.places.AutocompleteSessionToken();
var request = {
	input: valCal,
	sessionToken: sessionToken,
	location: GLLMontreal,
	radius: 200000 //meters
};
GAutocompleteService.getPlacePredictions(
	request, 
	function(predictions, status) {
		if (status == google.maps.places.PlacesServiceStatus.OK && predictions) {
			GPlacesService.getDetails(
				{
					placeId: predictions[0].place_id,
					fields: ['address_component', 'geometry', 'name']
				},
				function(place, status) {
					//window.alert(place.place.address);

					

					//window.alert(valCal);
					
					if (status == google.maps.places.PlacesServiceStatus.OK) {
						
						saveSessionVariable('lat', place.geometry.location.lat(), _complete);
        				saveSessionVariable('lng', place.geometry.location.lng(), _complete);

						saveSessionVariable('serve', serveValue, _complete);
						saveSessionVariable('location', valCal, _complete);
						saveSessionVariable('place', valCal, _complete);
						saveSessionVariable('field11', newRegionValue, _complete);
						saveSessionVariable('field12', newAggloValue , _complete);
						saveSessionVariable('field13', newVilleValue, _complete);



						url = updateQueryStringParameter(url, 'lat', place.geometry.location.lat());
						url = updateQueryStringParameter(url, 'lng', place.geometry.location.lng());
						url = updateQueryStringParameter(url, 'place',valCal);
						url = updateQueryStringParameter(url, 'field11', newRegionValue);
						url = updateQueryStringParameter(url, 'field12', newAggloValue);
						url = updateQueryStringParameter(url, 'field13', newVilleValue);
						url = updateQueryStringParameter(url, 'serve', serveValue);
						

						
						//window.processInfo(place, t.closest('.ref-ctn'));
						
						window.location.reload();
						
						// Final process is geolocalizeMeSave() in geolocalisation.js
					} else {
						// Error from google service, proceed nevertheless
						_start();
					}
				}
			);
		} else {
			// Error from google service, proceed nevertheless
			_start();
		}
	}
);

//////



            $(".specify-city-warning").slideUp(200);
            _start();
        }
        
        function _start() {
            if (placeInputValue === '') {
                url = removeURLParameter(url, 'place');
                placeValue = null;
            } else {
                url = updateQueryStringParameter(url, 'place', valCal);
                searchSort = true;
            }
            
            if (newRegionValue === '') {
                url = removeURLParameter(url, 'field11');
                field11Value = null;
            } else {
                url = updateQueryStringParameter(url, 'field11', newRegionValue);
                searchSort = true;
            }
            
            if (newAggloValue === '') {
                url = removeURLParameter(url, 'field12');
                field12Value = null;
            } else {
                url = updateQueryStringParameter(url, 'field12', newAggloValue);
                searchSort = true;
            }
            
            if (newVilleValue === '') {
                url = removeURLParameter(url, 'field13');
                field13Value = null;
            } else {
                url = updateQueryStringParameter(url, 'field13', newVilleValue);
                searchSort = true;
            }
            if (field16Value === '') {
                url = removeURLParameter(url, 'field16');
                field16Value = null;
            } else {
                url = updateQueryStringParameter(url, 'field16', field16Value);
                searchSort = true;
            }

			if (serveValue === '') {
                url = removeURLParameter(url, 'serve');
                serveValue = null;
            } else {
                url = updateQueryStringParameter(url, 'serve', serveValue);
                searchSort = true;
            }
            
            if (!searchSort) {
                url = removeURLParameter(url, 'sort');
                serveValue = null;
            } else {
                url = updateQueryStringParameter(url, 'sort', "proximity");
            }
            
            count = 6;
            saveSessionVariable('location', valCal, _complete);
            saveSessionVariable('serve', serveValue, _complete);
            saveSessionVariable('field11', newRegionValue, _complete);
            saveSessionVariable('field12', newAggloValue, _complete);
            saveSessionVariable('field13', newVilleValue, _complete);
            saveSessionVariable('field16', field16Value, _complete);
        }
        function _complete() {
            if (--count <= 0) {
                window.location.href = url;
            }
        }
	};
    
    var rechercheRegionServeChange = function (e) {
		
        saveSessionVariable('serve', e.currentTarget.value, function () {
			//url = updateQueryStringParameter(url, 'serve', e.currentTarget.value);
			
        });
		var url = window.location.href;
		url = updateQueryStringParameter(url, 'serve', e.currentTarget.value);
		window.location.replace(url);
		//window.location.reload();
    };
	
	var createCookie = function (name, value, days) {
		var expires;
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toGMTString();
		}
		else {
			expires = "";
		}
		document.cookie = name + "=" + value + expires + "; path=/";
	};

	var getCookie = function (c_name) {
		if (document.cookie.length > 0) {
			var c_start = document.cookie.indexOf(c_name + "=");
			if (c_start != -1) {
				c_start = c_start + c_name.length + 1;
				var c_end = document.cookie.indexOf(";", c_start);
				if (c_end == -1) {
					c_end = document.cookie.length;
				}
				return unescape(document.cookie.substring(c_start, c_end));
			}
		}
		return "";
	};
	
	var rechercheUpdateVue = function () {
		var t = $(this);
		
		if (t.hasClass('carte') && body.hasClass('open-list')) {
			body.removeClass('open-list').addClass('open-map');
			
			var newUrl = updateQueryStringParameter(removeURLParameter(location.href, 'list'), 'map', 'true');
			window.history.pushState({'pageId': 'recherche'}, 'pageId', newUrl);
		} else if (t.hasClass('list') && body.hasClass('open-map')) {
			rechercheShowList();
		}
	};
	
	var rechercheShowList = function () {
		var query = QueryString();
		body.removeClass('open-map').addClass('open-list');
		
		if (query.list !== 'true') {
            var newUrl = removeURLParameter(location.href, 'map');
			window.history.pushState({'pageId': 'recherche'}, 'pageId', newUrl);
		}
	};
	
	var rechercheHeaderFiltersDelBtnClick = function () {
		var t = $(this);
		var ctn = t.closest('.recherche-header-filters-items-inner-ctn');
        var filtersCtn = t.closest('.recherche-header-filters');
        
        $('.recherche-header-filters-items', ctn).val('');
		$('.recherche-filtre-region .dropdown-select-input', filtersCtn).val('all');
		$('.recherche-filtre-agglomeration .dropdown-select-input', filtersCtn).val('all');
		$('.recherche-filtre-ville .dropdown-select-input', filtersCtn).val('all');
		
        rechercheRegionInputSubmit.call(this);
	};

	var rechercheGeolocResetBtnClick = function () {
		var t = $(this);
		var ctn = t.closest('.recherche-pannel-index-mot-content');
		
		$('.recherche-pannel-index-mot-label-input.location-geo').val('');
		$('.recherche-pannel-index-mot-label-input.location').val('');
        $('.localize-popup-location').val('');
        $('.localize-popup-lat').val('');
        $('.localize-popup-lng').val('');
        $('.localize-popup-field11').val('');
        $('.localize-popup-field12').val('');
        $('.localize-popup-field13').val('');
        $('.localize-popup-serve').val('');
        
        var count = 8;
        saveSessionVariable('field11', '', _complete);
        saveSessionVariable('field12', '', _complete);
        saveSessionVariable('field13', '', _complete);
        saveSessionVariable('field16', '', _complete);
        saveSessionVariable('location', '', _complete);
        saveSessionVariable('serve', '', _complete);
        saveSessionVariable('lat', '', _complete);
        saveSessionVariable('lng', '', _complete);

        function _complete() {
        	if (--count <= 0) {
	    	    $(rechercheGeolocResetBtn).hide();
	    		$('.locality').text('-');
	    		$('.recherche-pannel-categorie-liste').attr('data-start-search', 'false');
        	}
        }
	};
	
	var rechercheOptionLinkUpdate = function () {
		rechercheOptionItemDel.each(function () {
			var links = $(this).attr('href');
			if (links !== undefined) {
				var newLinks = links.replace('=,', '=');
				
				$(this).attr('href', newLinks);
			}
		});
	};
	
	var recherchePopupLangItemClick = function () {
		var t = $(this);
		var pageLang = $('html').attr('lang');
		var handle = removeDiacritics(t.attr('data-value'));
		var query = QueryString();
		var lang = pageLang === 'fr' ? query.field4 : query.field5;
		var currLocation = window.location.href;
		var field = pageLang === 'fr' ? 'field4' : 'field5';
		var replace = pageLang === 'fr' ? /(field4=)[^\&]+/ : /(field5=)[^\&]+/;
		
		if (lang !== undefined) {
			currLocation = currLocation.replace(replace, '$1' + handle);
		} else {
			currLocation = updateQueryStringParameter(currLocation, field, handle);
		}
		
		location.replace(currLocation);
	};
	
	var recherchePopupRegionsItemClick = function () {
		var t = $(this);
		var pageLang = $('html').attr('lang');
		var handle = removeDiacritics(t.attr('data-value'));
		var query = QueryString();
		var regions = query.field9;
		var currLocation = window.location.href;
		var field = 'field9';
		var replace = /(field9=)[^\&]+/;
		
		if (regions !== undefined) {
			currLocation = currLocation.replace(replace, '$1' + handle);
		} else {
			currLocation = updateQueryStringParameter(currLocation, field, handle);
		}
		
		saveSessionVariable('region', handle, function () {
			location.replace(currLocation);
		});
	};
	
	var prepopulateRegionDropdown = function () {
		var value = getCookie('region-check');
		var btn = $('.dropdown-select-btn-value', recherchePopupRegionsItemCtn);
		var btnPopup = $('.dropdown-select-btn-value', recherchePopupRegion);
		var items = $('.dropdown-select-pannel-item', recherchePopupRegionsItemCtn);
		var itemsPopup = $('.dropdown-select-pannel-item', recherchePopupRegion);
		
		if (value.length !== 0) {
			btn.add(btnPopup).html(value);
		}
		
		items.add(itemsPopup).each(function () {
			var t = $(this);
			
			if (t.attr('data-value') === value) {
				t.hide();
			}
		});
        
        // Attach toogle events to the new dropdowns
        var bigCtn = $('.recherche-region-input-big-ctn').filter(':last()');
        var dropdownCtn = $('.dropdown-select', bigCtn);
        var dropdownBtn = $('.dropdown-select-btn', dropdownCtn);
        var dropdownlist = $('.dropdown-select-pannel', dropdownCtn);
        var dropdownlistItem = $('.dropdown-select-pannel-item', dropdownlist);
        dropdownBtn.add(dropdownlistItem).click(toggleContactDD);
        dropdownlistItem.click(dropdownUpdateValue);
	};
	
	var recherchePopupLangClear = function () {
		var pageLang = $('html').attr('lang');
		var query = QueryString();
		var lang = pageLang === 'fr' ? query.field4 : query.field5;
		var itemsExclude = [];
		var itemsSort = [];
		var ddInner = $('.dropdown-select-pannel-inner', recherchePopupLangItemCtn);
		
		if (lang !== undefined) {
			var langList = lang.split(',');
			
			recherchePopupLangItem.each(function () {
				var t = $(this);
				
				for(var i in langList) {
					if (t.attr('data-value') === langList[i]) {
						t.remove();
					}
				}
			});
		}
		
		for (var i = 0; i < recherchePopupLangItem.length; i++) {
			if ($(recherchePopupLangItem[i]).attr('data-exclude-order') === 'true') {
				itemsExclude.push(recherchePopupLangItem[i]);
			} else {
				itemsSort.push(recherchePopupLangItem[i]);
			}
		}
		
		itemsSort.sort(function (a,b) {
			if (a.innerHTML.toLowerCase() < b.innerHTML.toLowerCase())
				return -1;
			  else if (a.innerHTML.toLowerCase() > b.innerHTML.toLowerCase())
				return 1;
			  else 
				return 0;
		});
		
		ddInner.html('');
		
		for (var q = 0; q < itemsExclude.length; q++) {
			var item = itemsExclude[q];
			item.innerHTML = '';
			$(item).append($(item).attr('data-value'));
			
			ddInner.append(item);
		}
		
		for (var k = 0; k < itemsSort.length; k++) {
			var itemToSort = itemsSort[k];
			itemToSort.innerHTML = '';
			$(itemToSort).append($(itemToSort).attr('data-value'));
			
			ddInner.append(itemToSort);
		}
	};
	
	var recherchePopupRedirectBtnClick = function () {
		var url;
		var input = $('.recherche-popup-input');
		var inputVal = input.val().split(',')[0];
		var regionValue = $('.dropdown-select-btn-value span', recherchePopupRegion);
		
		if (inputVal.length !== 0) {
			url = updateQueryStringParameter(location.href, 'place', inputVal);
			
			var geocoder = new google.maps.Geocoder();
			
			geocoder.geocode( { 'address': input.val()}, function(results, status) {
			  if (status == google.maps.GeocoderStatus.OK) {
				var placeLat = results[0].geometry.location.lat();
				var placeLng = results[0].geometry.location.lng();
				
				url += '&lat=' + placeLat;
				url += '&lng=' + placeLng;
				url += '&sort=proximity';
			  } else {
				alert("Geocode was not successful for the following reason: " + status);
			  }
			  
			  if (regionValue.length !== 0) {
				  url += '&field9=' + regionValue.html();
			  }
			  
			  createCookie('popup-check', 'true', 1);
			  
			  location.replace(url);
			});
		} else if (inputVal.length === 0 && regionValue.length !== 0) {
			url = updateQueryStringParameter(location.href, 'field9', regionValue.html());
			  
			createCookie('popup-check', 'true', 1);
			  
			location.replace(url);
		} else {
			recherchePopupClose();
		}
	};
	
	var checkSubmitAndRefresh = function (e) {
		var ch = (typeof e.which == "number") ? e.which : e.keyCode;
		var pannelInput = $('.recherche-pannel-form .recherche-pannel-input');
		var popupInput = $('.recherche-popup-input.ville');
		
		if ((ch === 13 || ch === 10) && !pannelInput.is(':focus') && !popupInput.is(':focus')) {
			var pathArray = location.href.split( '/' );
			var protocol = pathArray[0];
			var host = pathArray[2];
			var pathname = location.pathname;
			var url = location.href;
			var parameters = getUrlVars();
			var parametersCount = countProperties(parameters);
			var fullUrl = url;
			
			//var inputQ = rechercheQuery;
			//var valQ = inputQ.val();
			
			var inputLocation = $('.recherche-header-filters-items.location');
			var valLocation = removeDiacritics(inputLocation.val().split(',')[0]);
			
			/*if (valQ.length !== 0) {*/
				/*if (parameters.q !== undefined) {
					//fullUrl = updateQueryStringParameter(fullUrl, 'q', valQ + ',' + parameters.q);
				} else {
					if (parametersCount === 0) {
						fullUrl += '?';
					} else {
						fullUrl += '&';
					}
					
					fullUrl += 'q=' + valQ;
					
					if (parameters.q !== undefined) {
						fullUrl += ',' + parameters.q;
					}
				}*/
				
				/*fullUrl = window.location.href.split('?')[0];
				fullUrl += '?q=' + valQ;
				
				if (parameters.place !== '' && parameters.place !== undefined) {
					fullUrl += '&place=';
					fullUrl += parameters.place;
				}
				
				if (parameters.lat !== '' && parameters.lat !== undefined) {
					fullUrl += '&lat=';
					fullUrl += parameters.lat;
				}
				
				if (parameters.lng !== '' && parameters.lng !== undefined) {
					fullUrl += '&lng=';
					fullUrl += parameters.lng;
				}
				
				if (parameters.sort !== '' && parameters.sort !== undefined) {
					fullUrl += '&sort=';
					fullUrl += parameters.sort;
				}
				
				if (parameters.field9 !== '' && parameters.field9 !== undefined) {
					fullUrl += '&field9=';
					fullUrl += parameters.field9;
				}
				
				location.replace(fullUrl);
				
				return false;
			}*/
			
			if (valLocation.length !== 0) {
				if (parameters.place !== undefined) {
					fullUrl = updateQueryStringParameter(fullUrl, 'place', valLocation);
				} else {
					if (parametersCount === 0) {
						fullUrl += '?';
					} else {
						fullUrl += '&';
					}
					
					fullUrl += 'place=' + valLocation;
				}
				
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode( { 'address': removeDiacritics(inputLocation.val())}, function(results, status) {
				  if (status == google.maps.GeocoderStatus.OK) {
					var placeLat = results[0].geometry.location.lat();
					var placeLng = results[0].geometry.location.lng();
					
					fullUrl = updateQueryStringParameter(fullUrl, 'lat', placeLat);
					fullUrl = updateQueryStringParameter(fullUrl, 'lng', placeLng);
					fullUrl = updateQueryStringParameter(fullUrl, 'sort', 'proximity');
					
					/*fullUrl += '&lat=' + placeLat;
					fullUrl += '&lng=' + placeLng;
					fullUrl += '&sort=proximity';*/
				  } else {
					alert("Geocode was not successful for the following reason: " + status);
				  }
				  
				  if (/*valQ.length !== 0 || */valLocation.length !== 0) {
					saveSessionVariable('location', valLocation, function () {
                        saveSessionVariable('lat', placeLat, function () {
                            saveSessionVariable('lng', placeLng, function () {
                                location.replace(fullUrl);
                            });
						});
					});
				  }
				});
			}
			
			/*if (valQ.length !== 0 || valLocation.length !== 0) {
				saveSessionVariable('location', valLocation, function () {
					location.replace(fullUrl);
				});
			}*/
		} else if ((ch === 13 || ch === 10) && popupInput.is(':focus')) {
			recherchePopupRedirectBtnClick();
		}
	};
	
	var rechercheOrderBtnDistClick = function (e) {
		var params = getUrlVars();
		var ctn = $('.recherche-content');
		var paramLat = params.lat !== undefined ? params.lat : ctn.data('lat');
		var paramLng = params.lng !== undefined ? params.lng : ctn.data('lng');
		var paramLocation = params.place !== undefined ? params.place : ctn.data('location');
		var lat = paramLat === undefined ? '' : paramLat;
		var lng = paramLng === undefined ? '' : paramLng;
		var location = paramLocation === undefined ? '' : paramLocation;
		
		if (location === undefined || lat === undefined || lng === undefined) {
			$('body').addClass('open-popup');
						
			return false;
		} 
	};
	
	var rechercheContentFiltreFiltresBtnClick = function () {
		var t = $(this);
		var ctn = t.closest('.recherche-header-top-inner');
		var content = $('.recherche-header-top-content', ctn);
		
		if (ctn.hasClass('open')) {
			ctn.removeClass('open');
			content.slideUp(300);
		} else {
			ctn.addClass('open');
			content.slideDown(300);
		}
	};
	
	var getUrlVars = function () {
		var vars = {}, hash;
		if (window.location.href.indexOf('?') !== -1) {
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for(var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				//vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		} else {
			return {};
		}
	};
	
	var countProperties = function (obj) {
		var count = 0;

		for(var prop in obj) {
			if(obj.hasOwnProperty(prop))
				++count;
		}

		return count;
	};
	
	var updateQueryStringParameter = function (uri, key, value) {
		var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
		var separator = uri.indexOf('?') !== -1 ? "&" : "?";
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + "=" + value + '$2');
		}
		else {
			return uri + separator + key + "=" + value;
		}
	};
	
	var removeURLParameter = function (url, parameter) {
		//prefer to use l.search if you have a location/link object
		var urlparts= url.split('?');   
		if (urlparts.length>=2) {

			var prefix= encodeURIComponent(parameter)+'=';
			var pars= urlparts[1].split(/[&;]/g);

			//reverse iteration as may be destructive
			for (var i= pars.length; i-- > 0;) {    
				//idiom for string.startsWith
				if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
					pars.splice(i, 1);
				}
			}

			url= urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
			return url;
		} else {
			return url;
		}
	};
	
	var QueryString = function () {
		// This function is anonymous, is executed immediately and 
		// the return value is assigned to QueryString!
		var query_string = {};
		var query = window.location.search.substring(1);
		var vars = query.split("&");
		for (var i=0;i<vars.length;i++) {
			var pair = vars[i].split("=");
					// If first entry with this name
			if (typeof query_string[pair[0]] === "undefined") {
				query_string[pair[0]] = decodeURIComponent(pair[1]);
					// If second entry with this name
			} else if (typeof query_string[pair[0]] === "string") {
				var arr = [ query_string[pair[0]],decodeURIComponent(pair[1]) ];
				query_string[pair[0]] = arr;
					// If third or later entry with this name
			} else {
				query_string[pair[0]].push(decodeURIComponent(pair[1]));
			}
		} 
		
		return query_string;
	};
    
	var checkForSuggestions = function (dropdownClass, input) {
		suggestionCurrentDropdown = $('.recherche-header-search-dropdown.' + dropdownClass);
		var val = removeDiacritics(input.val());
		
		if (val !== suggestionQuery) {
			if (val.length >= 3) {
				suggestionCurrentInput = input;
				var url = '/action/crgm?q=';
				url += val;
				
				var obj = ajax(url,function (response) {
					suggestionQuery = val;
					manageRechercheQueryPopup(response, suggestionCurrentDropdown);
				},true);
			} else {
				suggestionCurrentDropdown.removeClass('has-query');
				suggestionIsOpen = true;
			}
		}
	};
	
	var manageRechercheQueryPopup = function (response, dropdown) {
		var obj = JSON.parse(response.trim());
		
		var rechercheQueryOrgContent = $('.recherche-header-search-dropdown-col.org .recherche-header-search-dropdown-content', dropdown);
		var rechercheQueryTermsContent = $('.recherche-header-search-dropdown-col.terms .recherche-header-search-dropdown-content', dropdown);
		var rechercheQueryCatContent = $('.recherche-header-search-dropdown-col.cat .recherche-header-search-dropdown-content', dropdown);
		
		var rechercheQueryLinkCtn = $('.recherche-header-search-dropdown-link-ctn.hide', dropdown);
		var rechercheQueryLinkCatCtn = $('.recherche-header-search-dropdown-link-cat-ctn.hide', dropdown);
        var ctn = dropdown.closest(".recherche-pannel-index-mot-content");
        var inputLocation = $('.recherche-pannel-index-mot-label-input.location-geo', ctn);
		
		var pageOrganismeUrl = dropdown.attr('data-url-organisme');
		var pageRechercheUrl = dropdown.attr('data-url-recherche');
        
		rechercheQueryOrgContent.html('');
		rechercheQueryTermsContent.html('');
		rechercheQueryCatContent.html('');
		
		suggestionRow = 0;
		suggestionColumn = 1;
		
		$('.recherche-header-search-dropdown-col.org .recherche-header-search-dropdown-col-error').removeClass('show');
		$('.recherche-header-search-dropdown-col.terms .recherche-header-search-dropdown-col-error').removeClass('show');
		$('.recherche-header-search-dropdown-col.cat .recherche-header-search-dropdown-col-error').removeClass('show');
		
		if (obj.orgs.length === 0) {
			$('.recherche-header-search-dropdown-col.org .recherche-header-search-dropdown-col-error').addClass('show');
		}
		
		if (obj.terms.length === 0) {
			$('.recherche-header-search-dropdown-col.terms .recherche-header-search-dropdown-col-error').addClass('show');
		}
		
		if (obj.categories.length === 0) {
			$('.recherche-header-search-dropdown-col.cat .recherche-header-search-dropdown-col-error').addClass('show');
		}
		
		$.each(obj.orgs, function (key, value) {
			var orgUrl = pageOrganismeUrl + '/';
			orgUrl += decodeText(value.friendlyUrl);
			
			var newOrgElt = rechercheQueryLinkCtn.clone();
			var newOrgEltLink = $('.recherche-header-search-dropdown-link', newOrgElt);
			
			newOrgElt.removeClass('hide');
			newOrgEltLink.html(decodeText(value.name));
			newOrgEltLink.attr('href', orgUrl);
			
			rechercheQueryOrgContent.append(newOrgElt);
		});
		
		$.each(obj.terms, function (key, value) {
			var termsUrl = pageRechercheUrl + '?q=';
			termsUrl += encodeURIComponent('"'+value.term.replace(/&#(\d+);/g, function (m, n) { return String.fromCharCode(n); })+'"');
            if(inputLocation.length !== 0 && inputLocation.val() !== ''){
                termsUrl += "&sort=proximity";
            } else {
                termsUrl += "&sort=name";                
            }
			
			var newTermsElt = rechercheQueryLinkCtn.clone();
			var newTermsEltLink = $('.recherche-header-search-dropdown-link', newTermsElt);
			
			newTermsElt.removeClass('hide');
			newTermsEltLink.html(decodeText(value.term));
			newTermsEltLink.attr('href', termsUrl);
			
			rechercheQueryTermsContent.append(newTermsElt);
		});
		
		$.each(obj.categories, function (key, value) {
			var catUrl = pageRechercheUrl;
			
			if (decodeText(value.type) === 'sous-chapitre') {
				catUrl += '?cat-id=' + decodeText(value.parentId);
				catUrl += '&sub-cat=';
				
				if ($('html').attr('lang') === 'fr') {
					catUrl += decodeText(value.urlFr);
				} else {
					catUrl += decodeText(value.urlEn);
				}
			} else {
				catUrl += '?cat-id=' + decodeText(value.id);
			}
			
            if (inputLocation.length !== 0 && inputLocation.val() !== '') {
                catUrl += "&sort=proximity";
            } else {
                catUrl += "&sort=name";
            }
			var newCatElt = rechercheQueryLinkCatCtn.clone();
			var newCatEltLink = $('.recherche-header-search-dropdown-link-cat', newCatElt);
			var newCatEltLinkTitle = $('.recherche-header-search-dropdown-link-cat-title', newCatEltLink);
			var newCatEltLinkSubTitle = $('.recherche-header-search-dropdown-link-cat-sub-title', newCatEltLink);
			
			newCatElt.removeClass('hide');
			newCatEltLink.attr('href', catUrl);
			
			if (decodeText(value.type) === 'sous-chapitre') {
				newCatElt.attr('data-cat', 'cat-' + decodeText(value.parentId));
				newCatEltLinkTitle.html(decodeText(value.parentHandle));
			} else {
				newCatElt.attr('data-cat', 'cat-' + decodeText(value.id));
				
				if ($('html').attr('lang') === 'fr') {
					newCatEltLinkTitle.html(decodeText(value.handleFr));
				} else {
					newCatEltLinkTitle.html(decodeText(value.handleEn));
				}
			}
			
			
			if ($('html').attr('lang') === 'fr') {
				newCatEltLinkSubTitle.html(decodeText(value.handleFr));
			} else {
				newCatEltLinkSubTitle.html(decodeText(value.handleEn));
			}
			
			if (decodeText(value.type) !== 'sous-chapitre') {
				newCatEltLinkSubTitle.remove();
			}
			
			rechercheQueryCatContent.append(newCatElt);
		});
		
		$('.recherche-header-search-dropdown-col .recherche-header-search-dropdown-link').click(rechercheQueryPopupLink);
		
		suggestionCurrentDropdown.addClass('has-query');
		$(document).on('click', rechercheQueryPopupOutsideClick);
		
		if (!suggestionIsOpen) {
			$(document).on('keydown', moveInSuggestion);
			suggestionIsOpen = true;
		}
	};
	
	var rechercheQueryPopupLink = function () {
		var t = $(this);
		var ctn = t.closest('.recherche-pannel-index-mot-content');
		if (ctn.length !== 0) {
			var inputLocation = $('.recherche-pannel-index-mot-label-input.location-geo', ctn);
			var valLocation = removeDiacritics(inputLocation.val().split(',')[0]);
			var url = t.attr('href');
			
			var geocoder = new google.maps.Geocoder();
            if ($(".localize-popup-lat", ctn).val() !== '' && inputLocation.val().length !== 0) {
                var placeLat = $(".localize-popup-lat", ctn).val();
                var placeLng = $(".localize-popup-lng", ctn).val();

                url += '&place=' + inputLocation.val();
                url += '&lat=' + placeLat;
                url += '&lng=' + placeLng;
                url += '&sort=proximity';
                if (valLocation.length !== 0) {
                    saveSessionVariable('location', inputLocation.val(), function () {
                        saveSessionVariable('lat', placeLat, function () {
                            saveSessionVariable('lng', placeLng, function () {
                                if (url.indexOf('?') === -1) {
                                    var tempIndex = url.indexOf('&');
                                    url = url.substr(0, tempIndex) + '?' + url.substr(tempIndex + 1);
                                }
                                location.href = url;
                            });
                        });
                    });
                }
            } else if (valLocation.length !== 0) {
                geocoder.geocode({'address': removeDiacritics(inputLocation.val())}, function (results, status) {
                    var placeLat = '';
                    var placeLng = '';
                    if (status == google.maps.GeocoderStatus.OK) {
                        placeLat = results[0].geometry.location.lat();
                        placeLng = results[0].geometry.location.lng();
                    } else {
                        alert("Geocode was not successful for the following reason: " + status);
                    }

                    url += '&place=' + inputLocation.val();
                    url += '&lat=' + placeLat;
                    url += '&lng=' + placeLng;
                    url += '&sort=proximity';
                    saveSessionVariable('location', valLocation, function () {
                        saveSessionVariable('lat', placeLat, function () {
                            saveSessionVariable('lng', placeLng, function () {
                                var sym = "?";
                                if (url.indexOf("?") !== -1) {
                                    sym = "&";
                                }
//                                var u = "place=" + valLocation + "&lat=" + placeLat + "&lng=" + placeLng + "&sort=proximity";
								if (url.indexOf('?') === -1) {
									var tempIndex = url.indexOf('&');
									url = url.substr(0, tempIndex) + '?' + url.substr(tempIndex + 1);
								}
                                location.replace(url);
                            });
                        });
                    });
                });
            } else {
                location.replace(url);
            }
			
			return false;
		}
	};
	
	var moveInSuggestion = function (e) {
		var ch = (typeof e.which == "number") ? e.which : e.keyCode;
		var ctn = $('.recherche-header-search-dropdown.has-query');
		var allItems = $('.js-suggest-item:not(.hide) .js-suggest-item-link', ctn);
		
		var minCol = 1;
		var maxCol = 3;
		
		if (ch === 9 && suggestionIsOpen) {
			suggestionCurrentDropdown.removeClass('has-query');
			suggestionIsOpen = false;
			$(document).off('keydown', moveInSuggestion);
		} else if (allItems.length !== 0) {
			if([37, 38, 39, 40].indexOf(e.keyCode) > -1) {
				e.preventDefault();
				
				
				if (ch === 38) { //38 = up
					suggestionRow--;
				} else if (ch === 40) { //40 = down
					suggestionRow++;
				} else if (ch === 37) { //37 = left
					suggestionColumn--;
				} else if (ch === 39) { //39 = right
					suggestionColumn++;
				}
				
				if (suggestionColumn > maxCol) {
					suggestionColumn = maxCol;
				} else if (suggestionColumn < minCol) {
					suggestionColumn = minCol;
				}
				
				var col = $('.recherche-header-search-dropdown-col:eq('+(suggestionColumn - 1)+')', ctn);
				var itemsCol = $('.js-suggest-item:not(.hide) .js-suggest-item-link', col);
				
				while (itemsCol.length === 0) {
					suggestionColumn++;
					
					if (suggestionColumn > maxCol) {
						suggestionColumn = minCol;
					}
					
					col = $('.recherche-header-search-dropdown-col:eq('+(suggestionColumn - 1)+')', ctn);
					itemsCol = $('.js-suggest-item:not(.hide) .js-suggest-item-link', col);
				}
				
				if (suggestionRow > itemsCol.length) {
					if (suggestionColumn !== maxCol) {
						suggestionColumn++;
						suggestionRow = 1;
						
						col = $('.recherche-header-search-dropdown-col:eq('+(suggestionColumn - 1)+')', ctn);
						itemsCol = $('.js-suggest-item:not(.hide) .js-suggest-item-link', col);
						
						while (itemsCol.length === 0) {
							suggestionColumn++;
							
							if (suggestionColumn > maxCol) {
								suggestionColumn = minCol;
							}
							
							col = $('.recherche-header-search-dropdown-col:eq('+(suggestionColumn - 1)+')', ctn);
							itemsCol = $('.js-suggest-item:not(.hide) .js-suggest-item-link', col);
						}
					} else {
						suggestionRow = itemsCol.length;
					}
				} else if (suggestionRow < 0) {
					suggestionRow = 0;
				} 
				
				var selectedItem = $('.js-suggest-item:not(.hide):eq('+(suggestionRow - 1)+') .js-suggest-item-link', col);
				allItems.removeClass('key-selected');
				
				if (suggestionRow === 0) {
					suggestionCurrentInput.focus();
				} else {
					selectedItem.addClass('key-selected');
					suggestionCurrentInput.blur();
				}
			}
		}
	};
	
	var rechercheQueryPopupOutsideClick = function (event) {
		if (!$(event.target).closest('.recherche-header-search-dropdown').length) {
			$('.recherche-header-search-dropdown').removeClass('has-query');
			
			$(document).off('click', rechercheQueryPopupOutsideClick);
			$(document).off('keydown', moveInSuggestion);
			suggestionIsOpen = false;
		}
	};
	
	var rechercheQueryPopupFormFocus = function (dropdownClass, input) {
		suggestionCurrentDropdown = $('.recherche-header-search-dropdown.' + dropdownClass);
		
		if (input.val().length >= 3) {
			$(document).on('mousedown', rechercheQueryPopupOutsideClick);
			suggestionCurrentDropdown.addClass('has-query');
		} else {
			suggestionIsOpen = false;
			$(document).off('keydown', moveInSuggestion);
		}
	};
	
	var rechercheOptionItemDelClick = function () {
		var t = $(this);
		if (t.attr('data-session') === 'location') {
			saveSessionVariable('location', '', function () {
				saveSessionVariable('lng', '', function () {
					saveSessionVariable('lat', '', function () {
						location.reload();
					});
				});
			});
		} else if (t.attr('data-session') !== undefined) {
			saveSessionVariable(t.attr('data-session'), '', function () {
				location.reload();
			});
		}
		
		
	};
	
	var gmapResterResearchBtnClick = function () {
		var t = $(this);
		
		saveSessionVariable('region', '', function () {
			window.location.href = t.attr('href');
		});
		
		return false;
	};
	
    var expandFilterList = function (e) {
        var t = $(e ? e.currentTarget || this : this);
        var ctn = t.parent();
        
        if (ctn.hasClass('expanded')) {
            ctn.removeClass('expanded')
                    .find('.recherche-filtre-list-item[data-hidden]').hide();
            t.find('.on').show();
            t.find('.off').hide();
        } else {
            ctn.addClass('expanded')
                    .find('.recherche-filtre-list-item[data-hidden]').show();
            t.find('.on').hide();
            t.find('.off').show();
        }
    };
    
    var goToHref = function (e) {
        var t = $(e ? e.currentTarget || this : this);
        window.location.href = t.closest('a').prop('href');
    };
    
    var addViewParam = function (e) {
        var t = $(e ? e.currentTarget || this : this);
        var href = t.attr('href');
        var regex = /[\?\&]map=true/;
        
        if (getUrlVars().hasOwnProperty('map')) {
            if (!href.match(regex)) {
                t.attr('href', href + (href.indexOf('?') == -1 ? '?' : '&') + 'map=true');
            }
        } else {
            t.attr('href', href.replace(regex, ''));
        }
    };

	$(window).load(function () {
        if (window.google) {
            // Assign google AutocompleteService to use it widely
            GLLMontreal = new google.maps.LatLng(45.5, -73.6833334);
            GAutocompleteService = new google.maps.places.AutocompleteService();
            // Initiate montreal coordinates and empty div to use google PlacesService
            var dummy = document.createElement('DIV');
            GPlacesService = new google.maps.places.PlacesService(
                new google.maps.Map(dummy, {center: GLLMontreal})
            );
        }
        

		saveSessionVariable('lat', '');
        saveSessionVariable('lng', '');
		currURL = document.location;
		
		rechercheFiltresListSousitem = $('.recherche-filtre-sub-list-item-inner');
		rechercheFiltresLabel = $('.recherche-header-filters-items-label');
		
		rechercherContentFiltreListeBtn = $('.recherche-content-filtre-liste-toggle-btn');
		rechercheContentMapResultsBtn = $('.recherche-content-map-resultat-list-btn');
		rechercheContentFiltreFiltresBtn = $('.recherche-content-filtre-filtre-toggle-btn');
		rechercheRegionInput = $('.recherche-region-input-list .dropdown-select-pannel-item');
		rechercheRegionBtn = $('.recherche-header-filters .recherche-region-btn');
		
		rechercheOptionItemDel = $('.recherche-option-item-del');
		
		recherchePopup = $('.recherche-popup');
		recherchePopupCloseBtn = $('.recherche-popup-close-btn', recherchePopup);
		recherchePopupLangItemCtn = $('.recherche-header-lang-dropdown');
		recherchePopupRegionsItemCtn = $('.recherche-header-regions-dropdown');
		recherchePopupClosePannel = $('.recherche-popup-btn-close-pannel', recherchePopup);
		recherchePopupLangItem = $('.dropdown-select-pannel-item', recherchePopupLangItemCtn);
		recherchePopupRegionsItem = $('.dropdown-select-pannel-item', recherchePopupRegionsItemCtn);
		recherchePopupRegion = $('.recherche-popup-region-dropdown', recherchePopup);
		recherchePopupRedirectBtn = $('.recherche-popup-btn', recherchePopup);
		
		rechercheOrganisationVueBtn = $('.recherche-header-view-button');
		
		rechercheHeaderFiltersDelBtn = $('.recherche-header-filters-items-del');
		rechercheGeolocResetBtn = $('.remove-locality');
		
		rechercheOrderBtnDist = $('.recherche-content-liste-order-btn.dist');
		
		gmapResterResearchBtn = $('.gmap-no-results-relancer-btn');
		
		rechercheQuery = $('.recherche-header-filters-items.q');
		homeRechercheQuery = $('.recherche-pannel-input_homepage');
		sidebarRechercheQuery = $('#recherche-pannel-input_side-pannel');
		
		$(".nano").nanoScroller();
		
		checkIfPopup();
		rechercheOptionLinkUpdate();
		recherchePopupLangClear();
		rechercheFiltreTiroirOpen();
		
		var suggestionsTimerHome;
		var suggestionsTimerSidebar;
		var suggestionsTimer;
		
		if (rechercheQuery.length !== 0) {
			rechercheQuery.focus(function () {
				rechercheQueryPopupFormFocus('recherche-dd', rechercheQuery);
			});
		}
		if (homeRechercheQuery.length !== 0) {
			homeRechercheQuery.focus(function () {
				rechercheQueryPopupFormFocus('homepage-dd', $(this));
			});
		}
		if (sidebarRechercheQuery.length !== 0) {
			sidebarRechercheQuery.focus(function () {
				rechercheQueryPopupFormFocus('side-pannel-dd', $(this));
			});
		}

        if(window.matchMedia("(max-width: 768px)").matches){
        	console.log("Query match");
            homeRechercheQuery.on('focus', function() {
            	console.log($(this).offset().top);
                window.scrollTo(0, $(this).offset().top);
                // document.body.scrollTop = $(this).offset().top;
            });
        }
		
		$(document).keyup(function (e) {
			var ch = (typeof e.which == "number") ? e.which : e.keyCode;
			
			if (ch === 9) {
				if (suggestionCurrentInput !== undefined) {
					if (suggestionCurrentInput.length !== 0) {
						if (suggestionCurrentInput.is(':focus')) {
							suggestionCurrentDropdown.addClass('has-query');
							suggestionIsOpen = true;
							$(document).on('keydown', moveInSuggestion);
						}
					}
				}
			}
			
			if ($('body').hasClass('section-recherche') || $('body').hasClass('section-search')) {
				checkSubmitAndRefresh(e);
				
				if (rechercheQuery.is(':focus')) {
					clearTimeout(suggestionsTimer);
						if (rechercheQuery.val().length !== 0) {
						suggestionsTimer = setTimeout(function () {
							checkForSuggestions('recherche-dd', rechercheQuery);
						}, 500);
					}
				}
			} else {
				if (homeRechercheQuery.is(':focus')) {
					clearTimeout(suggestionsTimerHome);
					if (homeRechercheQuery.val().length !== 0) {
						suggestionsTimerHome = setTimeout(function () {
							checkForSuggestions('homepage-dd', homeRechercheQuery);
						}, 500);
					}
				}
			}
			
			if (sidebarRechercheQuery.is(':focus')) {
				clearTimeout(suggestionsTimerSidebar);
				if (sidebarRechercheQuery.val().length !== 0) {
					suggestionsTimerSidebar = setTimeout(function () {
						checkForSuggestions('side-pannel-dd', sidebarRechercheQuery);
					}, 500);
				}
			}
		});
		
		rechercheRegionInputChange();
		rechercheRegionSort();
		
        $('.recherche-header-top-breadcrumb-serve .form-checkbox-input').on('change', rechercheRegionServeChange);
        $('.recherche-region-full-wrapper').on('click', '.recherche-region-input-list .dropdown-select-pannel-item', rechercheRegionInputChange);
		rechercheRegionBtn.click(rechercheRegionInputSubmit);
		//rechercheFiltresListSousitem.click(rechercheSubfilterToggle);
		rechercherContentFiltreListeBtn.click(rechercherContentFiltreListeBtnToggle);
		rechercheFiltresLabel.click(rechercheFiltresLabeltoggle);
		recherchePopupCloseBtn.add(recherchePopupClosePannel).click(recherchePopupClose);
		rechercheOrganisationVueBtn.click(rechercheUpdateVue);
		rechercheHeaderFiltersDelBtn.click(rechercheHeaderFiltersDelBtnClick);
		rechercheGeolocResetBtn.click(rechercheGeolocResetBtnClick);
		recherchePopupLangItem.click(recherchePopupLangItemClick);
		recherchePopupRegionsItem.click(recherchePopupRegionsItemClick);
		recherchePopupRedirectBtn.click(recherchePopupRedirectBtnClick);
		rechercheContentMapResultsBtn.click(rechercheShowList);
		rechercheOrderBtnDist.click(rechercheOrderBtnDistClick);
		rechercheContentFiltreFiltresBtn.click(rechercheContentFiltreFiltresBtnClick);
		rechercheOptionItemDel.click(rechercheOptionItemDelClick);
		gmapResterResearchBtn.click(gmapResterResearchBtnClick);
        
        $('.recherche-header-top-filter-open').on('click', rechercheContentFiltreFiltresBtnClick);
        $('.recherche-filtre-list-expander').on('click', expandFilterList);
        $('.recherche-filtre-list-item-button .form-checkbox-input').on('change', goToHref);
        $('.js-scan-recherche-view').on('click', addViewParam);
	});
	
	function removeDiacritics (str) {
		if (str !== undefined && str !== '') {
			return str.replace(/[^\u0000-\u007E]/g, function(a){ 
			   return diacriticsMap[a] || a; 
			});
		} else {
			return '';
		}
	} 
	
	var defaultDiacriticsRemovalMap = [
		{'base':'A', 'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
		{'base':'AA','letters':'\uA732'},
		{'base':'AE','letters':'\u00C6\u01FC\u01E2'},
		{'base':'AO','letters':'\uA734'},
		{'base':'AU','letters':'\uA736'},
		{'base':'AV','letters':'\uA738\uA73A'},
		{'base':'AY','letters':'\uA73C'},
		{'base':'B', 'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
		{'base':'C', 'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
		{'base':'D', 'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\u00D0'},
		{'base':'DZ','letters':'\u01F1\u01C4'},
		{'base':'Dz','letters':'\u01F2\u01C5'},
		{'base':'E', 'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
		{'base':'F', 'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
		{'base':'G', 'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
		{'base':'H', 'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
		{'base':'I', 'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
		{'base':'J', 'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
		{'base':'K', 'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
		{'base':'L', 'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
		{'base':'LJ','letters':'\u01C7'},
		{'base':'Lj','letters':'\u01C8'},
		{'base':'M', 'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
		{'base':'N', 'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
		{'base':'NJ','letters':'\u01CA'},
		{'base':'Nj','letters':'\u01CB'},
		{'base':'O', 'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
		{'base':'OI','letters':'\u01A2'},
		{'base':'OO','letters':'\uA74E'},
		{'base':'OU','letters':'\u0222'},
		{'base':'OE','letters':'\u008C\u0152'},
		{'base':'oe','letters':'\u009C\u0153'},
		{'base':'P', 'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
		{'base':'Q', 'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
		{'base':'R', 'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
		{'base':'S', 'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
		{'base':'T', 'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
		{'base':'TZ','letters':'\uA728'},
		{'base':'U', 'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
		{'base':'V', 'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
		{'base':'VY','letters':'\uA760'},
		{'base':'W', 'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
		{'base':'X', 'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
		{'base':'Y', 'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
		{'base':'Z', 'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
		{'base':'a', 'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
		{'base':'aa','letters':'\uA733'},
		{'base':'ae','letters':'\u00E6\u01FD\u01E3'},
		{'base':'ao','letters':'\uA735'},
		{'base':'au','letters':'\uA737'},
		{'base':'av','letters':'\uA739\uA73B'},
		{'base':'ay','letters':'\uA73D'},
		{'base':'b', 'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
		{'base':'c', 'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
		{'base':'d', 'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
		{'base':'dz','letters':'\u01F3\u01C6'},
		{'base':'e', 'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
		{'base':'f', 'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
		{'base':'g', 'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
		{'base':'h', 'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
		{'base':'hv','letters':'\u0195'},
		{'base':'i', 'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
		{'base':'j', 'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
		{'base':'k', 'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
		{'base':'l', 'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
		{'base':'lj','letters':'\u01C9'},
		{'base':'m', 'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
		{'base':'n', 'letters':'\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
		{'base':'nj','letters':'\u01CC'},
		{'base':'o', 'letters':'\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
		{'base':'oi','letters':'\u01A3'},
		{'base':'ou','letters':'\u0223'},
		{'base':'oo','letters':'\uA74F'},
		{'base':'p','letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
		{'base':'q','letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
		{'base':'r','letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
		{'base':'s','letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
		{'base':'t','letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
		{'base':'tz','letters':'\uA729'},
		{'base':'u','letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
		{'base':'v','letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
		{'base':'vy','letters':'\uA761'},
		{'base':'w','letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
		{'base':'x','letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
		{'base':'y','letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
		{'base':'z','letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
	];
	
	var diacriticsMap = {};
	for (var i=0; i < defaultDiacriticsRemovalMap .length; i++){
		var letters = defaultDiacriticsRemovalMap [i].letters;
		for (var j=0; j < letters.length ; j++){
			diacriticsMap[letters[j]] = defaultDiacriticsRemovalMap [i].base;
		}
	}

	// Add plus and minus buttons
	var index = 1;
	var z_index = 4998;
	var recherche_list = [];
	var regionList = [];
	var agglomerationList = [];
	var cityList = [];
	$('#recherche-block').hide();

	var setDeleteBtnShow = function setDeleteBtnShow(index) {
		if (index <= 1) {
			$('.delete-recherche-region').hide();
		} else {
			$('.delete-recherche-region').show();
		}
	};

	if (getCookie("recherche_index") != "") {
		index = parseInt(getCookie("recherche_index"));
		if (index < 1) {
			index = 1;
		}
	}
	for (var _i = 0; _i < index; _i++) {
		z_index = z_index - index;
		$('.recherche-region-container').append('<div class="newrow newrow_' + _i + ' recherche-region-input-big-ctn recherche-region-input-list flexbox ref-ctn" id="' + _i + '" style="z-index: ' + z_index + ';"></div>');
		var recherche_block = $('#recherche-block').html();
		$('.newrow').html(recherche_block);
		recherche_list.push(_i);
	}

	setDeleteBtnShow(index);

	$('.recherche-region-full-wrapper').on('click', '.plus-recherche-region', function () {
		if (recherche_list.at(-1)) {
			index = recherche_list.at(-1) + 1;
		}
		z_index = z_index - index;
		$('.recherche-region-container').append('<div class="newrow newrow_' + index + ' recherche-region-input-big-ctn recherche-region-input-list flexbox ref-ctn" id="' + index + '" style="z-index: ' + z_index + ';"></div>');
		//$(this).closest('.newrow').attr('id',index.toString());
		var recherche_block = $('#recherche-block').html();
		$('.newrow_' + index).html(recherche_block);
		recherche_list.push(index);
		//index ++;
		var no = recherche_list.length;
		setDeleteBtnShow(no);
		setCookie("recherche_index", no, 30);
		prepopulateRegionDropdown();
		// console.log("index******### click",index);
	});

	$('.recherche-region-full-wrapper').on('click', '.delete-recherche-region', function () {
		var id = $(this).closest('.newrow').attr('id');
		if (id != undefined) {
			$('.newrow_' + id + '').remove();
			// $('.newrow_'+(index-1)+'').remove();
			//index --;
			var recherche_index = recherche_list.indexOf(parseInt(id));
			if (recherche_index > -1) {
				recherche_list.splice(recherche_index, 1);
			}
			var no = recherche_list.length;
			setDeleteBtnShow(no);
			setCookie("recherche_index", no, 30);
			// console.log("index******recherche_list",recherche_list);
			// console.log("index******id",id);
			// console.log("index******delete",recherche_index);
			// Remove from fields
			delete regionList[id];
			delete agglomerationList[id];
			delete cityList[id];
			// regionList.splice(id, 1);
			// agglomerationList.splice(id, 1);
			// cityList.splice(id, 1);
			regionListSetup(regionList);
			agglomerationListSetup(agglomerationList);
			cityListSetup(cityList);
		}
	});

	// Add values to Field11, 12, and 13
	var regionListSetup = function regionListSetup(regionList) {
		var regionListString = "all";
		if (regionList != undefined && regionList.length != 0) {
			regionList.forEach(function (element) {
				if (regionListString == 'all') {
					regionListString = element;
				} else {
					regionListString = regionListString + ', ' + element;
				}
			});
		} else {
			regionListString = "all";
		}
		$('.custom-directory-form').find("[name='field11']").val(regionListString);
		return;
	};
	var agglomerationListSetup = function agglomerationListSetup(agglomerationList) {
		var agglomerationListString = "all";
		if (agglomerationList != undefined && agglomerationList.length != 0) {
			agglomerationList.forEach(function (element) {
				if (agglomerationListString == 'all') {
					agglomerationListString = element;
				} else {
					agglomerationListString = agglomerationListString + ', ' + element;
				}
			});
		} else {
			agglomerationListString = "all";
		}
		$('.custom-directory-form').find("[name='field12']").val(agglomerationListString);
		return;
	};
	var cityListSetup = function cityListSetup(cityList) {
		var cityListString = "all";
		if (cityList != undefined && cityList.length != 0) {
			cityList.forEach(function (element) {
				if (cityListString == 'all') {
					cityListString = element;
				} else {
					cityListString = cityListString + ', ' + element;
				}
			});
		} else {
			cityListString = "all";
		}
		$('.custom-directory-form').find("[name='field13']").val(cityListString);
		return;
	};

	$('.recherche-region-full-wrapper .recherche-filtre-ville').on('click', '.dropdown-select-pannel-item', function () {
		var id = $(this).closest('.newrow').attr('id');
		cityList[id] = $(this).data("value");
		agglomerationList[id] = $(this).data("agglo");
		regionList[id] = $(this).data("region");
		regionListSetup(regionList);
		agglomerationListSetup(agglomerationList);
		cityListSetup(cityList);
		// console.log("cityList",cityList);
		// console.log("agglomerationList",agglomerationList);
		// console.log("regionList",regionList);
	});

	$('.recherche-region-full-wrapper .recherche-filtre-agglomeration').on('click', '.dropdown-select-pannel-item', function () {
		var id = $(this).closest('.newrow').attr('id');
		agglomerationList[id] = $(this).data("value");
		regionList[id] = $(this).data("region");
		regionListSetup(regionList);
		agglomerationListSetup(agglomerationList);
	});

	$('.recherche-region-full-wrapper .recherche-filtre-region').on('click', '.dropdown-select-pannel-item', function () {
		var id = $(this).closest('.newrow').attr('id');
		regionList[id] = $(this).data("value");
		regionListSetup(regionList);
	});
	
})(jQuery);
